document.addEventListener('DOMContentLoaded', function () {

    const CART_CONTAINER = document.getElementById('cart-items');
    if (!CART_CONTAINER) return;

    const FREE_SHIPPING_THRESHOLD = 4998;

    // MINIMUM QUANTITY RULE
    const MIN_PRODUCT_ID = 8493118488768;
    const MIN_QTY = 50;

    const money = c => '$' + (c / 100).toFixed(2);

    /* ---------- FETCH CART ---------- */
    async function getCart() {
        const res = await fetch('/cart.js');
        return await res.json();
    }

    /* ---------- ENFORCE MIN QTY ---------- */
    async function enforceMinimum(cart) {

        let needsUpdate = false;

        for (let item of cart.items) {
            if (item.product_id === MIN_PRODUCT_ID && item.quantity < MIN_QTY) {

                needsUpdate = true;

                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: item.key,
                        quantity: MIN_QTY
                    })
                });
            }
        }

        // reload updated cart if changed
        if (needsUpdate) {
            return await getCart();
        }

        return cart;
    }

    /* ---------- RENDER ITEM ---------- */
    function renderItem(item) {
        return `
        <div class="product-card" 
            data-line-item-id="${item.key}" 
            data-product-id="${item.product_id}">

            <div class="product-img">
                <img src="${item.image}" alt="${item.product_title}">
            </div>

            <div class="product-info">
                <div>
                    <div class="product-title">${item.product_title}
                    ${item.variant_title && item.variant_title !== "Default Title" 
  ? `<div class="variant-title">${item.variant_title}</div>` 
  : ""}
                    </div>
                    <a href="#" class="delete-item delete-btn">✕</a>
                </div>

                <div class="d-flex align-items-center">
                    <div class="quantity-control">

                        <button class="qty-btn minus"><svg width="25" height="25" viewBox="0 0 36 36" fill="none">
                   <path d="M21 15V25.5M15 15V25.5M9 9V26.7C9 28.3802 9 29.2197 9.32698 29.8614C9.6146 30.4259 10.0732 30.8857 10.6377 31.1733C11.2788 31.5 12.1185 31.5 13.7954 31.5H22.2046C23.8815 31.5 24.72 31.5 25.3611 31.1733C25.9256 30.8857 26.3857 30.4259 26.6733 29.8614C27 29.2203 27 28.3815 27 26.7046V9" stroke="white" stroke-width="1.2"/>
                 </svg></button>

                        <span class="quantity-number">${item.quantity}</span>

                        <button class="qty-btn plus"><svg width="15" height="15" viewBox="0 0 14 14" fill="none">
                    <path d="M7 1V13M1 7H13"
                          stroke="white"
                         stroke-width="2"
                          stroke-linecap="round"/>
                </svg></button>

                    </div>

                    <div class="price-tag ms-3">
                        ${money(item.price * item.quantity)}
                    </div>
                </div>
            </div>
        </div>`;
    }

    /* ---------- RENDER CART ---------- */
    function renderCart(cart) {

        CART_CONTAINER.innerHTML = cart.items.map(renderItem).join('');

        document.querySelectorAll('.price-box')
            .forEach(el => el.textContent = money(cart.original_total_price));

        updateShippingBar(cart.original_total_price);
    }

    /* ---------- UPDATE CART ---------- */
    async function updateItem(key, qty) {

        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: key,
                quantity: qty
            })
        });

        const updatedCart = await getCart();
        renderCart(updatedCart);
    }

    /* ---------- SHIPPING BAR ---------- */
    function updateShippingBar(cartTotal) {

        const box = document.querySelector('.shipping-box2');
        if (!box) return;

        const message = box.querySelector('#shipping-message');
        const bar = box.querySelector('.progress-bar');

        if (!message || !bar) return;

        const remaining = Math.max(FREE_SHIPPING_THRESHOLD - cartTotal, 0);
        let percentage = Math.min((cartTotal / FREE_SHIPPING_THRESHOLD) * 100, 100);

        if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
            message.textContent = 'Congratulations! 10% OFF unlocked!';
            percentage = 100;
        } else {
            message.textContent = `Add 2 products and get 10% off`;
        }

        bar.style.width = percentage + '%';
        bar.setAttribute('aria-valuenow', Math.round(percentage));
    }

    /* ---------- EVENTS ---------- */
    document.body.addEventListener('click', function (e) {

        const card = e.target.closest('.product-card');
        if (!card) return;

        const key = card.dataset.lineItemId;
        const productId = parseInt(card.dataset.productId);
        const currentQty = +card.querySelector('.quantity-number').textContent;

        /* PLUS */
        if (e.target.closest('.plus')) {
            e.preventDefault();

            let newQty = currentQty + 1;

            // ensure min quantity
            if (productId === MIN_PRODUCT_ID && newQty < MIN_QTY) {
                newQty = MIN_QTY;
            }

            updateItem(key, newQty);
        }

        /* MINUS */
        if (e.target.closest('.minus')) {
            e.preventDefault();

            if (productId === MIN_PRODUCT_ID && currentQty <= MIN_QTY) {
                alert('Minimum quantity is 50');
                return;
            }

            updateItem(key, Math.max(currentQty - 1, 0));
        }

        /* DELETE */
        if (e.target.classList.contains('delete-item')) {

    e.preventDefault();

    const confirmDelete = confirm('Are you sure you want to remove this item?');
    if (!confirmDelete) return;

    const card = e.target.closest('.product-card');
    updateItem(card.dataset.lineItemId, 0);
}

    });

    /* ---------- INIT ---------- */
    async function init() {
        let cart = await getCart();
        cart = await enforceMinimum(cart); // 🔥 key fix
        renderCart(cart);
    }

    init();

});